<template>
  <HeadingLv1 :text="$route.params.year + '年ニュース一覧'" />
  <div class="news">
    <div class="primary">
      <div v-if="state.loading">
        <!-- <p>読込中</p> -->
      </div>
      <div v-else>
        <div v-if="totalPosts > 0" class="list">
          <NewsLists :lists="lists" />
        </div>
        <Alert v-else text="ただいまお知らせは存在しません。" />
      </div>
      <Pager
        v-if="totalPosts > perPage && $route.name == 'NewsYear'"
        :total-count="Number(totalPosts)"
        :page-num="1"
        :row-cnt="perPage"
        @move-page="movePage"
      />
      <Pager
        v-else-if="$route.name == 'NewsYearPage'"
        :total-count="Number(totalPosts)"
        :page-num="Number($route.params.page)"
        :row-cnt="perPage"
        @move-page="movePage"
      />
    </div>
    <div class="secondary">
      <NewsArchive />
    </div>
  </div>
</template>

<script lang="ts">
import { reactive, ref, watch } from 'vue'
import { useRoute, useRouter } from 'vue-router'

import HeadingLv1 from '@/components/elements/HeadingLv1.vue'
import NewsLists from '@/components/block/NewsLists_OUTDATED.vue'
import Alert from '@/components/elements/Alert.vue'
import Pager from '@/components/block/Pager.vue'
import NewsArchive from '@/components/block/NewsArchive.vue'

import { axiosSetting } from '@/utils/axiosSetting'

export default {
  name: 'NewsYear',
  components: {
    HeadingLv1,
    NewsLists,
    Alert,
    Pager,
    NewsArchive
  },
  // beforeRouteEnter: async (to: any) => {
  beforeRouteEnter: (to: any) => {
    // console.log(to.meta.breadCrumb[1])

    to.meta.breadCrumb.splice(1)

    to.meta.breadCrumb.push({ label: to.params.year + '年ニュース一覧' })
    document.title = `${to.params.year}年ニュース一覧 | ${document.title}`
  },
  beforeRouteUpdate: (to: any) => {
    document.title = `${to.params.year}年ニュース一覧 | ${document.title}`
  },
  setup() {
    const state = reactive({
      loading: true
    })
    const lists = ref([])
    const totalPosts = ref(0)

    const route = useRoute()
    const router = useRouter()

    const ajax = axiosSetting('cms', 'block')

    const perPage = 20

    const currentUrl: any = () => {
      if (route.name == 'NewsYear') {
        return `${process.env.VUE_APP_WPAPI_URL}wp-json/wp/v2/news?per_page=${perPage}&before=${route.params.year}-12-31T23:59:59&after=${route.params.year}-01-01T00:00:00`
      } else if (route.name == 'NewsYearPage') {
        return `${process.env.VUE_APP_WPAPI_URL}wp-json/wp/v2/news?per_page=${perPage}&page=${route.params.page}&before=${route.params.year}-12-31T23:59:59&after=${route.params.year}-01-01T00:00:00`
      }
    }

    const getLists = () => {
      ajax
        .get(currentUrl())
        .then((res) => {
          lists.value = res.data
          totalPosts.value = res.headers['x-wp-total']
        })
        .finally(() => {
          state.loading = false
        })
    }

    const movePage = (num: number) => {
      const path = route.path
      const regexp = /news\/year\/\d*\/\d*/g
      const matches = path.match(regexp)
      let nextPagePath = ''

      if (num > 1 && matches !== null) {
        const year = matches[0].split('/')

        nextPagePath = path.replace(matches[0], `news/year/${year[2]}/${num}`)
      }

      if (num === 1 && matches !== null) {
        const year = matches[0].split('/')

        nextPagePath = path.replace(matches[0], `news/year/${year[2]}/${num}`)
      }

      if (num > 1 && matches === null) nextPagePath = `${path}/${num}`

      if (num === 1 && matches === null) nextPagePath = path

      router.push(nextPagePath)
    }

    getLists()

    watch(
      () => route.path,
      () => {
        getLists()
      }
    )

    return {
      state,
      lists,
      totalPosts,
      perPage,
      movePage
    }
  }
}
</script>

<style lang="scss" scoped>
@use 'src/styles/abstracts/mixins';
@use 'src/styles/abstracts/variables' as var;

.news {
  @include mixins.media() {
    display: grid;
    grid-template-columns: 1fr 242px;
    gap: 40px;
    padding: 0 20px;
    max-width: 1128px;
    margin: 0 auto;
  }
}

.primary {
  padding: 0 16px;
  margin-bottom: 48px;
  @include mixins.media() {
    padding: 0;
    margin-bottom: 0;
  }
}

.list {
  // margin-bottom: 4px;
  @include mixins.media() {
    border-bottom: 1px solid var.$color-border-gray;
    margin-bottom: 32px;
  }
}

// .secondary {
// }
</style>
